



























import { Vue, Component } from 'vue-property-decorator'
import BleProvider from '@/ble'
import { bleMockInit } from '@/ble/mock/bleMock'
import { BleDeviceTypes } from '@/constants/ble'
import * as envType from '@/constants/envType'
import { BleProviderEventTypes } from '@/ble/constants'

@Component
export default class BleSample extends Vue {
  message = '未接続です。'
  recevingContent = 'ここにデータが表示されます。'
  unsubscribe: (() => void) | null = null
  selectedDevice = BleDeviceTypes.ECG_SERVICE
  deviceOptions = {
    [BleDeviceTypes.ELECTRONIC_BLOOD_PRESSURE_MONITOR]: {
      text: 'ニプロ電子血圧計 ニプロ（A＆D）NBP-1BLE',
      eventType: BleProviderEventTypes.RECEIVE_ELECTRONIC_BLOOD_PRESSURE_MONITOR
    },
    [BleDeviceTypes.MEDICAL_BLOOD_PRESSURE_MONITOR]: {
      text: 'ニプロ医科向け血圧計 ニプロ UM-212',
      eventType: BleProviderEventTypes.RECEIVE_MEDICAL_BLOOD_PRESSURE_MONITOR
    },
    [BleDeviceTypes.ELECTRONIC_THERMOMETER]: {
      text: 'ニプロ電子体温計 ニプロ NSM-1BLE',
      eventType: BleProviderEventTypes.RECEIVE_ELECTRONIC_THERMOMETER
    },
    [BleDeviceTypes.BLOOD_SUGAR_LEVEL_MEASUREMENT]: {
      text: '血糖測定器 ニプロ ケアファストLink',
      eventType: BleProviderEventTypes.RECEIVE_BLOOD_SUGAR_LEVEL_MEASUREMENT
    },
    [BleDeviceTypes.SPO2_MONITOR_MIGHTY_SAT]: {
      text: 'SPO2モニター（スポット） MASIMO マイティサット',
      eventType: BleProviderEventTypes.RECEIVE_SPO2_MONITOR_MIGHTY_SAT
    },
    [BleDeviceTypes.ECG_SERVICE]: {
      text: '心電送信機: ECG Service (独自) 心電波形、心拍数',
      eventType: BleProviderEventTypes.RECEIVE_ECG_SERVICE
    },
    [BleDeviceTypes.SPO2_MONITOR_TM1121]: {
      text: 'SPO2モニター（24ｈ式）',
      eventType: BleProviderEventTypes.RECEIVE_SPO2_MONITOR_TM1121
    },
    [BleDeviceTypes.NONCONTACT_THERMOMETER]: {
      text: '非接触体温計',
      eventType: BleProviderEventTypes.RECEIVE_NONCONTACT_THERMOMETER
    },
    [BleDeviceTypes.BODY_COMPOSITION_MONITOR]: {
      text: '体組成計 ニプロ',
      eventType: BleProviderEventTypes.RECEIVE_BODY_COMPOSITION_MONITOR
    }
  }

  get deviceTypes() {
    return Object.keys(this.deviceOptions).map(Number)
  }

  async handleClickConnect() {
    // (1) テスト用のBleオブジェクトのモックを初期化
    if (process.env.NODE_ENV === envType.DEVELOPMENT) {
      // テストするデバイスタイプを配列でbleMockInitの引数に渡す
      bleMockInit([this.selectedDevice])
    }

    // (2) 環境の確認
    if (!BleProvider.isSupport()) {
      this.message = 'ご利用の環境はBLE接続に対応していません。'
      return
    }

    // (3) ラッパーの初期化
    console.log('do init...')
    await BleProvider.init()

    // (4) デバイススキャン開始
    console.log('do scan...')
    const targetAddress = await new Promise<string>(resolve => {
      BleProvider.startScan()

      const unsubscribe = BleProvider.addListener(
        BleProviderEventTypes.ADD_DEVICE,
        (deviceName, address) => {
          const device = BleProvider.getDevice(address)
          if (device && device.deviceType === this.selectedDevice) {
            unsubscribe()
            resolve(address)
          }
        }
      )
    })

    // (5) 接続
    console.log('do connect...')
    await BleProvider.connect(targetAddress)

    this.message = '接続が完了しました。'
  }

  handleClickReceiveStart() {
    // データ受信開始（接続前でも設定は可能です。）
    if (typeof this.unsubscribe === 'function') {
      this.unsubscribe()
    }

    const unsubscribe = BleProvider.addListener(
      this.deviceOptions[this.selectedDevice].eventType,
      (readVal: any) => {
        this.recevingContent = Object.keys(readVal).reduce((content, key) => {
          return content + `${key}: ${String((readVal as any)[key])}<br>`
        }, '')
      }
    )

    this.unsubscribe = unsubscribe
  }

  async handleClickDisconnect() {
    const deviceInfo = BleProvider.getDeviceByDeviceType(this.selectedDevice)
    if (!deviceInfo) {
      return
    }
    await BleProvider.disconnect(deviceInfo.address)
    if (typeof this.unsubscribe === 'function') {
      this.unsubscribe()
    }
    this.message = '切断しました。'
  }
}
